import React from 'react'
import './Spinner.scss';

const Spinner = () => (
        <div className="SpinnerWrapper">
            <div className="spinner">
            </div>
        </div>
   
);

export default Spinner;